import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const styles = () => ({
  cssLabel: {
    "&$cssFocused": {
      color: "#C8102E"
    }
  },
  cssFocused: {},
  underline: {
    "&:before": {
      borderBottom: "1px solid rgba(0, 0, 0, 0.12) !important"
    },
    "&:after": {
      borderBottom: "2px solid #C8102E"
    },
  }
});

function MuiTextField(props) {
  const { classes, ...otherProps } = props;

  return (
    <TextField
      className={props.disabled ? "mui-textfield-readonly" : ""}
      {...otherProps}
      InputLabelProps={{
        shrink: true,
        classes: {
          root: classes.cssLabel,
          focused: classes.cssFocused,
        }
      }}
      InputProps={{
        classes: {
          root: classes.underline
        }
      }}
    />
  );
}

MuiTextField.defaultProps = {
  disabled: false,
};

MuiTextField.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(MuiTextField);
